import React, { useEffect, useState } from "react";
import { makeStyles } from 'tss-react/mui';
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const useStyles = makeStyles()(theme => ({
    chips: {
        display: "flex",
        flexWrap: "wrap",
    },
    chip: {
        margin: 2,
    },
    selectContainer: {
        width: "100%",
        textAlign: "left",
    },
}));

const SelectUser = ({ selectUserid, onChange, companyId }) => {
    const { classes } = useStyles();
    const [users, setUsers] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const  { data } = await api.get("/users/list", {
                    params: {
                      companyId: companyId,
                    }
                });
                setUsers(data);

            } catch (err) {
                toastError(err);
            }
        })();
    }, []);

    const handleChangeUser = e => {
        onChange(e.target.value);
    };

    return (
        <FormControl fullWidth margin="dense" size="small" className={classes.selectContainer}>
            <Select
                fullWidth
                displayEmpty
                variant="outlined"
                value={selectUserid ?? ""}
                onChange={handleChangeUser}
                renderValue={(value) =>
                    value ? users.find((u) => u.id === value)?.name || "Todos los usuarios" : "Todos los usuarios"
                }
            >
                <MenuItem key='' value=''>
                    Todos los usuarios
                </MenuItem>

                {users.map(users => (
                    <MenuItem key={users.id} value={users.id}>
                        {users.name}
                    </MenuItem>
                ))}

            </Select>
        </FormControl>
    );
};





export default SelectUser;
